import BaseRoulette_Images from 'BaseRoulette/Assets/Graphics/**/*.png';
import BaseRoulette_Json from 'BaseRoulette/Assets/**/*.json';
import BaseRoulette_Xml from 'BaseRoulette/Assets/**/*.xml';
import BaseRoulette_MP3 from 'BaseRoulette/Assets/Audio/*.mp3';
import BaseRoulette_M4A from 'BaseRoulette/Assets/Audio/*.m4a';

import { JackpotLevel, JackpotStatus } from "@core/Logic/Links/IMAXA/IMAXAProtocol";
import { Constants } from "@core/Utils/Constants";
import { Module } from "@core/Modules/Module";
import { WinType } from '@core/Logic/Bets';
import { Language } from '@core/GUI/Language';
import { Client } from '@core/Client';

export class LuckyNumberJackpot extends Module {
    protected levels: Array<{ enabled: boolean, levelName: string, color: number[], backgroundSprite?: Phaser.GameObjects.Sprite, titleText?: Phaser.GameObjects.BitmapText, valueText?: Phaser.GameObjects.BitmapText, values: JackpotLevel, displayedValue: number, startingValue: number, animationTimeLeft: number, minBet?: number }> = new Array<{ enabled: boolean, levelName: string, color: number[], backgroundSprite?: Phaser.GameObjects.Sprite, titleText?: Phaser.GameObjects.BitmapText, valueText?: Phaser.GameObjects.BitmapText, values: JackpotLevel, displayedValue: number, startingValue: number, animationTimeLeft: number, minBet?: number }>();
    protected preregisteredLevelNames: string[] = ["JACKPOT GOLD", "JACKPOT SILVER", "JACKPOT BRONZE", "JACKPOT EMERALD"]; //most valuable to least valuable
    protected preregisteredLevelColors: number[][] = [[0xf7e8a2, 0xf1d55b, 0xebc314, 0xd3b012], [0xffffff, 0xffffff, 0xffffff, 0xffffff], [0xffff88, 0xffff88, 0x913c00, 0x913c00], [0xfdffa6, 0x6ec047, 0x006700, 0xf5ffc6]]; //gold, silver, bronze, emerald
    protected focusedLevel: number = -1;
    protected luckyNumberSelected: number = -1;
    protected winNumber: number = -1;
    protected shouldBeHidden: boolean = false; //do not update positions, do not toggle visibility unless told to
    protected lastShowMoney: boolean = false;

    private luckyNumberMarker: Phaser.GameObjects.Sprite;
    private luckyNumberMarkerColor: number = 0xf1d55b;
    private luckyNumberMarkerWinColor: number = 0x6699ff;

    constructor() {
        super();

        Client.game.events.addListener(Constants.EVENTS.JACKPOT_UPDATE, (data: any) => { this.JackpotUpdate(data) });
        Client.game.events.addListener(Constants.EVENTS.JACKPOT_WON, (data: any) => { this.JackpotWon(data) });
        Client.game.events.addListener(Constants.EVENTS.JACKPOT_WAS_WON, (data: any) => { this.JackpotWasWon(data) });
        Client.game.events.addListener(Constants.EVENTS.JACKPOT_STATE_LUCKY_LEVEL, (data: number) => { this.JackpotLevelChange(data) });
        Client.game.events.addListener(Constants.EVENTS.JACKPOT_STATE_LUCKY_NUMBER, (data: any) => { this.JackpotNumberChange(data) });
        Client.game.events.addListener(Constants.EVENTS.WIN_NUMBER, (data: any) => { this.SetWinNumber(data) });

        let i = 0;
        Client.logic.setup.Jackpot.levels.forEach(jackpotLevel => {
            let newLevel = {
                enabled: jackpotLevel.status != JackpotStatus.DISABLED,
                levelName: this.preregisteredLevelNames[i],
                color: this.preregisteredLevelColors[i],
                backgroundSprite: null,
                titleText: null,
                valueText: null,
                values: jackpotLevel,
                displayedValue: jackpotLevel.pot,
                startingValue: jackpotLevel.pot,
                animationTimeLeft: 0,
                minBet: jackpotLevel.minBet
            }
            this.levels.push(newLevel);
            i++;
        });
    }

    SetWinNumber(number: number) {
        this.winNumber = number;

        if (!this.ready)
            return;

        if (this.luckyNumberMarker.visible) {
            if (this.winNumber == this.luckyNumberSelected)
                this.luckyNumberMarker.tint = this.luckyNumberMarkerWinColor
            else
                this.luckyNumberMarker.tint = this.luckyNumberMarkerColor
        }
    }

    JackpotNumberChange(data: number) {
        // console.log("Jackpot number changed : " + data);
        this.luckyNumberSelected = data;

        if (!this.ready)
            return;

        this.luckyNumberMarker.tint = this.luckyNumberMarkerColor

        if (this.luckyNumberSelected < 0 || this.shouldBeHidden) {
            this.luckyNumberMarker.visible = false;
        }
        else {
            this.luckyNumberMarker.visible = true;
            this.UpdatePosition();
        }
    }

    JackpotLevelChange(data: number) {
        // console.log("Jackpot level changed : " + data);
        this.focusedLevel = data;

        if (!this.ready)
            return;

        this.UpdatePosition();
    }

    JackpotWon(data: any) {
        if (!this.ready)
            return;

        let wonAmount: string = Client.logic.showMoney ? Language.InternationalNumberFormat.format(Client.logic.BalanceManager.CreditToMoney(data.totalWon)).toString() + " " + Client.logic.setup.Jackpot.currency : data.totalWon.toString();
        Client.game.events.emit(Constants.EVENTS.PLAY_WIN, WinType.JACKPOT, wonAmount);
    }

    JackpotWasWon(data: any) {
    }

    JackpotUpdate(data: any) {
        let packet: Array<JackpotLevel> = data;
        let i = 0;
        packet.forEach(level => {
            this.levels[i].values = level;

            if (level.status == JackpotStatus.DISABLED)
                this.levels[i].enabled = false;
            else
                this.levels[i].enabled = true;

            if (this.levels[i].enabled) {
                this.levels[i].animationTimeLeft = Constants.PANEL.ANIMATION_TIME;
            }
            i++;
        });
    }

    Load(): void {
        this.scene.load.atlas(Constants.SPRITESHEET_JACKPOT_LEVEL_BACKGROUND, BaseRoulette_Images.SilverJackpotPlayer, BaseRoulette_Json.Graphics.SilverJackpotPlayer);
        this.scene.load.atlas(Constants.SPRITESHEET_JACKPOT_LUCKY_MARKER, BaseRoulette_Images.LuckyNumberJackpotFieldGlow, BaseRoulette_Json.Graphics.LuckyNumberJackpotFieldGlow);
        this.scene.load.atlas(Constants.SPRITESHEET_PARTICLES, BaseRoulette_Images.Particles, BaseRoulette_Json.Graphics.Particles);
        this.scene.load.bitmapFont('jackpotSilver', BaseRoulette_Images.Fonts.JackpotSilver_0, BaseRoulette_Xml.Graphics.Fonts.JackpotSilver);
        this.scene.load.bitmapFont('jackpotTitle', BaseRoulette_Images.Fonts.JackpotTitle_0, BaseRoulette_Xml.Graphics.Fonts.JackpotTitle);
        this.scene.load.audio(Constants.SOUNDS.JACKPOT_WIN, [BaseRoulette_MP3.jackpot_win, BaseRoulette_M4A.jackpot_win]);
        this.scene.load.atlas(Constants.SPRITESHEET_PARTICLES, BaseRoulette_Images.Particles, BaseRoulette_Json.Graphics.Particles);

        this.scene.load.once(Phaser.Loader.Events.COMPLETE, () => {

            this.scene.anims.create({
                key: "jackpotBackgroundShine",
                frames: this.scene.anims.generateFrameNames(Constants.SPRITESHEET_JACKPOT_LEVEL_BACKGROUND, {
                    start: 0,
                    end: 49,
                    suffix: ".png"
                }),
                frameRate: 15,
                repeat: -1
            });
            this.scene.anims.create({
                key: "jackpotNumberMarker",
                frames: this.scene.anims.generateFrameNames(Constants.SPRITESHEET_JACKPOT_LUCKY_MARKER, {
                    start: 0,
                    end: 11,
                    suffix: ".png"
                }),
                frameRate: 30,
                repeat: -1
            });

            this.luckyNumberMarker = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "jackpotNumberMarker")
            this.luckyNumberMarker.tint = this.luckyNumberMarkerColor;
            this.luckyNumberMarker.play("jackpotNumberMarker");
            this.luckyNumberMarker.setOrigin(0.5);
            this.luckyNumberMarker.addToUpdateList();
            this.luckyNumberMarker.visible = false;

            this.scene.children.add(this.luckyNumberMarker);
            this.luckyNumberMarker.setDepth(-1000);

            let i = 0;
            this.levels.forEach(level => {
                level.backgroundSprite = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "jackpotBackgroundShine")
                level.backgroundSprite.play("jackpotBackgroundShine");
                level.backgroundSprite.stop();
                level.backgroundSprite.setOrigin(0, 0.5);
                level.backgroundSprite.setTint(level.color[0], level.color[1], level.color[2], level.color[3]);
                level.backgroundSprite.addToUpdateList();
                setTimeout(() => {
                    level.backgroundSprite.play("jackpotBackgroundShine");
                }, i * 1000);
                this.container.add(level.backgroundSprite);

                level.valueText = new Phaser.GameObjects.BitmapText(this.scene, 0, 0, 'jackpotSilver', "999.999.999,99 EUR", 20);
                level.valueText.setOrigin(0.5);
                level.valueText.setTint(level.color[0], level.color[1], level.color[2], level.color[3]);
                level.valueText.text = Client.logic.showMoney ? Language.InternationalNumberFormat.format(level.displayedValue) + " " + Client.logic.setup.Jackpot.currency : Client.logic.BalanceManager.MoneyToCredit(level.displayedValue).toString();

                this.container.add(level.valueText);

                level.titleText = new Phaser.GameObjects.BitmapText(this.scene, 0, 0, 'jackpotTitle', this.preregisteredLevelNames[i], 15);
                level.titleText.setOrigin(0.5);
                this.container.add(level.titleText);

                i++;
            });

            this.ready = true;
            this.JackpotLevelChange(this.focusedLevel);
            this.JackpotNumberChange(this.luckyNumberSelected);
            this.SetWinNumber(this.winNumber);
            this.UpdatePosition();

            Client.logic.ReloadModules();

            this.lastShowMoney = Client.logic.showMoney;
        });
        this.scene.load.start();
    }

    UpdatePosition(levelsOnly: boolean = false): void {
        if (!this.ready || this.shouldBeHidden)
            return;

        let visibleLevels = 0;
        let ii = 0;
        this.levels.forEach(level => {
            if (level.enabled && (this.focusedLevel < 0 || this.focusedLevel == ii)) {
                visibleLevels += 1;
            }
            ii++;
        });

        let i = 0;
        this.levels.forEach((level, index) => {
            if (this.focusedLevel < 0 && visibleLevels == 4) {
                level.backgroundSprite.visible = true;
                level.valueText.visible = true;
                level.titleText.visible = true;

                level.backgroundSprite.setDisplaySize(this.container.width * 0.85, this.container.height);
                level.backgroundSprite.setScale(Math.min(level.backgroundSprite.scaleX, level.backgroundSprite.scaleY));
                level.backgroundSprite.x = (- 70 * level.backgroundSprite.scale) + level.backgroundSprite.displayWidth * 0.65 * (index % 2);
                level.backgroundSprite.y = this.container.height / 2 - (level.backgroundSprite.displayHeight / 4) * ((index % 2) + 1 - i);

                level.valueText.fontSize = (28 - (5 * (level.valueText.text.length / 18))) * level.backgroundSprite.scale;
                level.valueText.x = level.backgroundSprite.x + level.backgroundSprite.displayWidth / 2;
                level.valueText.y = level.backgroundSprite.y + 4 * level.backgroundSprite.scale;

                level.titleText.fontSize = 13 * level.backgroundSprite.scale;
                level.titleText.x = level.backgroundSprite.x + level.backgroundSprite.displayWidth / 2;
                level.titleText.y = level.backgroundSprite.y - 14 * level.backgroundSprite.scale;

                i++;
            }
            else if (level.enabled && (this.focusedLevel < 0 || this.focusedLevel == index)) {
                level.backgroundSprite.visible = true;
                level.valueText.visible = true;
                level.titleText.visible = true;

                level.backgroundSprite.setDisplaySize(this.container.width * 1.5, ((this.container.height * 2) / visibleLevels));
                level.backgroundSprite.setScale(Math.min(level.backgroundSprite.scaleX, level.backgroundSprite.scaleY));
                level.backgroundSprite.x = - 70 * level.backgroundSprite.scale;
                level.backgroundSprite.y = this.container.height / 2 - (level.backgroundSprite.displayHeight / 2) * (visibleLevels / 2 - (i + 0.5));

                level.valueText.fontSize = (28 - (5 * (level.valueText.text.length / 18))) * level.backgroundSprite.scale;
                level.valueText.x = level.backgroundSprite.x + level.backgroundSprite.displayWidth / 2;
                level.valueText.y = level.backgroundSprite.y + 4 * level.backgroundSprite.scale;

                level.titleText.fontSize = 13 * level.backgroundSprite.scale;
                level.titleText.x = level.backgroundSprite.x + level.backgroundSprite.displayWidth / 2;
                level.titleText.y = level.backgroundSprite.y - 14 * level.backgroundSprite.scale;

                i++;
            }
            else {
                level.backgroundSprite.visible = false;
                level.valueText.visible = false;
                level.titleText.visible = false;
            }
        });

        if (this.luckyNumberMarker.visible && !levelsOnly) {
            let size = 0;
            if (Client.logic.IsBoard) {
                size = this.board.boardButtons[1].displayWidth * 1.6;
                this.luckyNumberMarker.x = this.board.x + (this.board.boardButtons[this.luckyNumberSelected].x + this.board.boardButtons[this.luckyNumberSelected].displayWidth / 2) * this.board.scaleX;
                this.luckyNumberMarker.y = this.board.y + (this.board.boardButtons[this.luckyNumberSelected].y + this.board.boardButtons[this.luckyNumberSelected].displayHeight / 2) * this.board.scaleY;
            }
            else {
                size = (this.track.trackButtons[1].displayWidth * 2.25) / 4;
                let coordinates = { x: 0, y: 0 };
                Client.logic.bets.GetNumberXY(this.luckyNumberSelected, coordinates);
                this.luckyNumberMarker.x = this.track.x + (this.track.hotSpotsTableTrack[coordinates.x][coordinates.y].x * this.track.scaleX);
                this.luckyNumberMarker.y = this.track.y + (this.track.hotSpotsTableTrack[coordinates.x][coordinates.y].y * this.track.scaleY);
            }
            this.luckyNumberMarker.setDisplaySize(size, size);
        }
    }

    ToggleVisibility(visible: boolean): void {
        this.shouldBeHidden = !visible;

        this.luckyNumberMarker.visible = visible && this.luckyNumberSelected >= 0;

        this.levels.forEach(level => {
            level.backgroundSprite.visible = visible;
            level.titleText.visible = visible;
            level.valueText.visible = visible;
        });

        if (!this.shouldBeHidden) // we are toggled back into visible, update positions
            this.UpdatePosition(true);
    }

    public Update(time: number): void {
        if (!this.ready || this.shouldBeHidden)
            return;

        this.levels.forEach(level => {
            if (level.enabled) {
                if (level.values.pot != level.startingValue || this.lastShowMoney != Client.logic.showMoney) {
                    level.animationTimeLeft = Math.max(level.animationTimeLeft - time / 1000, 0)
                    level.displayedValue = level.startingValue + (level.values.pot - level.startingValue) * (1 - level.animationTimeLeft / (Constants.PANEL.ANIMATION_TIME))

                    level.valueText.text = Client.logic.showMoney ? Language.InternationalNumberFormat.format(level.displayedValue) + " " + Client.logic.setup.Jackpot.currency : Client.logic.BalanceManager.MoneyToCredit(level.displayedValue).toString();

                    level.valueText.fontSize = (28 - (5 * (level.valueText.text.length / 18))) * level.backgroundSprite.scale;

                    if (level.animationTimeLeft == 0) {
                        level.startingValue = level.values.pot
                    }
                }
            }
        });

        this.lastShowMoney = Client.logic.showMoney;
    }
}